<i18n src='@/locale/department-localization.json'></i18n>

<template>
    <v-wm-form-dialog
        :formTitle="formTitle"
        :disableSave="!item.code || !item.name || !item.branch_code"
        @save="Save"
        @cancel="$emit('cancel')"
    >
        <v-row dense>
            <v-col cols="12">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.code"
                    :label="$t('Dep_Code')"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.name"
                    :label="$t('Department')"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <v-wm-organization-select
                    parent-branch
                    v-model="item.branch_code"
                    :label="$t('Dep_Branch')"
                ></v-wm-organization-select>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <v-wm-ehr-section-select
                    v-model="item.ehr_section"
                    :label="$t('EhrSection')"
                ></v-wm-ehr-section-select>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="4">
                <v-checkbox
                    v-model="item.forHR"
                    :label="$t('DepartmentLocale.ForHR')"
                ></v-checkbox>
            </v-col>
            <v-col cols="4">
                <v-checkbox
                    v-model="item.forSupply"
                    :label="$t('DepartmentLocale.ForSupply')"
                ></v-checkbox>
            </v-col>
            <v-col cols="4">
                <v-checkbox
                    v-model="item.forResearch"
                    :label="$t('DepartmentLocale.ForResearch')"
                ></v-checkbox>
            </v-col>
            <v-col cols="4">
                <v-checkbox
                    v-model="item.forDiagnosis"
                    :label="$t('DepartmentLocale.ForDiagnosis')"
                ></v-checkbox>
            </v-col>
            <v-col cols="4">
                <v-checkbox
                    v-model="item.forLaying"
                    :label="$t('DepartmentLocale.ForLaying')"
                ></v-checkbox>
            </v-col>
            <v-col cols="4">
                <v-checkbox
                    v-model="item.forPersonPosition"
                    :label="$t('DepartmentLocale.ForPersonPosition')"
                ></v-checkbox>
            </v-col>
            <v-col cols="4">
                <v-checkbox
                    v-model="item.homeVisit"
                    :label="$t('DepartmentLocale.HomeVisit')"
                ></v-checkbox>
            </v-col>
            <v-col cols="4">
                <v-checkbox
                    v-model="item.humanitarian"
                    :label="$t('DepartmentLocale.Humanitarian')"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <person-select
                    v-model="item.head"
                    :label="$t('DepartmentLocale.Head')"
                ></person-select>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <v-wm-organization-select
                    v-model="item.groupOrganizationId"
                    :label="$t('DepartmentLocale.GroupOrganization')"
                ></v-wm-organization-select>
            </v-col>
        </v-row>
    </v-wm-form-dialog>
</template>

<script>
import VWmFormDialog from '@/component/form-dialog.vue';
import VWmOrganizationSelect from '@/component/organization-select.vue';
import VWmEhrSectionSelect from '@/component/ehr-section-select.vue';
import departmentService from '@/service/department-service';
import personSelect from '../person-select.vue';

export default {
    components: {
        VWmFormDialog,
        VWmOrganizationSelect,
        VWmEhrSectionSelect,
        personSelect,
    },
    props: {
        newItem: {
            type: Boolean,
            required: true,
        },
        formTitle: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },
    methods: {
        Save() {
            if (this.newItem) {
                departmentService.add(this.item).then(() => this.$emit('save'));
            } else {
                departmentService
                    .edit(this.item)
                    .then(() => this.$emit('save'));
            }
        },
    },
};
</script>

<style>
</style>